<template>
  <div
    class="guestbook-header"
    v-if="!fetchingHeaderInformaton && isHeaderVisible()"
  >
    <!-- <div
      class="guestbook-header__header"
      :style="{
        'background-color': this.guestBookHeader.backgroundColor,
        color: guestBookHeader.textColor
          ? guestBookHeader.textColor
          : getCorrectTextColor(),
      }"
      v-if="includeName || includeRoom"
    > -->
      <!-- <div class="guestbook-header__header__item" v-if="includeName">
        <div class="icon__person">
          <svg
            width="28"
            height="32"
            viewBox="0 0 28 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              :style="{
                fill: guestBookHeader.textColor
                  ? guestBookHeader.textColor
                  : getCorrectTextColor(),
              }"
              d="M14 16C18.4188 16 22 12.4187 22 8C22 3.58125 18.4188 0 14 0C9.58125 0 6 3.58125 6 8C6 12.4187 9.58125 16 14 16ZM19.6 18H18.5562C17.1687 18.6375 15.625 19 14 19C12.375 19 10.8375 18.6375 9.44375 18H8.4C3.7625 18 0 21.7625 0 26.4V29C0 30.6562 1.34375 32 3 32H25C26.6562 32 28 30.6562 28 29V26.4C28 21.7625 24.2375 18 19.6 18Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="header-item__text">{{ nameFieldText }}</div>
      </div> -->
      <!-- <div class="guestbook-header__header__item" v-if="includeRoom">
        <div class="header-item__text">{{ roomFieldText }}</div>
        <div class="icon__room">
          <svg
            width="22"
            height="37"
            viewBox="0 0 22 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              :style="{
                fill: guestBookHeader.textColor
                  ? guestBookHeader.textColor
                  : getCorrectTextColor(),
              }"
              d="M7.33333 3.7H0V33.3H7.33333V37L22 33.3V3.7L7.33333 0V3.7ZM1.83333 5.55H7.33333V31.45H1.83333V5.55ZM10.615 19.9615C10.3217 19.9615 10.0558 19.8073 9.8175 19.499C9.57917 19.1907 9.46 18.8268 9.46 18.4075C9.46 17.9882 9.57917 17.6213 9.8175 17.3067C10.0558 16.9923 10.3217 16.835 10.615 16.835C10.9083 16.835 11.1711 16.9892 11.4033 17.2975C11.6356 17.6058 11.7517 17.9758 11.7517 18.4075C11.7517 18.8268 11.6356 19.1907 11.4033 19.499C11.1711 19.8073 10.9083 19.9615 10.615 19.9615Z"
              fill="white"
            />
          </svg>
        </div>
      </div> -->
    <!-- </div> -->
    <div
      class="guestbook-header__main"
      :style="{
        'background-color': this.guestBookHeader.backgroundColor,
        color: guestBookHeader.textColor
          ? guestBookHeader.textColor
          : getCorrectTextColor(),
      }"
    >
      <div
        v-if="this.guestBookHeader.imageActive"
        class="guestbook-header__main__image-container"
      >
        <img v-bind:src="appropriateImage" />
      </div>
      <div
        v-else
        class="guestbook-header__main__video-container"
        :style="{ 'background-color': this.guestBookHeader.backgroundColor }"
      >
        <div class="embed-container">
          <iframe
            v-bind:src="this.guestBookHeader.videoPath"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div
        class="guestbook-header__main__text"
        :style="{ 'background-color': this.guestBookHeader.backgroundColor }"
        v-html="this.guestBookHeader.contents[localLanguageTypesIndex]"
      ></div>
    </div>
  </div>
</template>

<script>
import { db } from "../firebase.js";
import bus from "../bus.js";
import getCurrentLanguageIndexMixin from "@/mixins/getCurrentLanguageIndexMixin";
import cookieMixin from "@/mixins/cookieMixin";
import newLanguageTypesFormatMixin from '@/mixins/newLanguageTypesFormatMixin';
import "../vue-awesome-icons.js";

export default {
  mixins: [
    cookieMixin,
    getCurrentLanguageIndexMixin,
    newLanguageTypesFormatMixin
  ],
  props: {
    secondLang: Boolean,
    cookieExists: String,
    guestPhase: String,
  },
  data() {
    return {
      fetchingHeaderInformaton: true,
      localLanguageTypesIndex: 0
    };
  },
  async created() {
    this.localLanguageTypesIndex = await this._getCurrentLanguageIndex(this.$customerId, this.getCookie('activeLanguage'));
  },
  firebase() {
    return {
      activeGuestInformation: {
        source: db.ref(`activeguests/${this.$customerId}/${this.$hotelId}/${this.$route.params.guestid}`),
        asObject: true,
      },
      guestBookHeader: {
        source: db.ref(`hotels/${this.$customerId}/${this.$hotelId}/headerContent`),
        asObject: true,
        readyCallback: () => {
          this.fetchingHeaderInformaton = false;
          bus.$emit("fetchLazyComponents");
        },
      },
    };
  },
  methods: {
    getCorrectTextColor() {
      let hex = this.guestBookHeader.backgroundColor;
      let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

      let hRed = hexToR(hex);
      let hGreen = hexToG(hex);
      let hBlue = hexToB(hex);

      function hexToR(h) {
        return parseInt(cutHex(h).substring(0, 2), 16);
      }
      function hexToG(h) {
        return parseInt(cutHex(h).substring(2, 4), 16);
      }
      function hexToB(h) {
        return parseInt(cutHex(h).substring(4, 6), 16);
      }
      function cutHex(h) {
        return String(h).charAt(0) == "#"
          ? String(h).substring(1, 7)
          : String(h);
      }

      let cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
      if (cBrightness > threshold) {
        return "#000000";
      } else {
        return "#ffffff";
      }
    },
    isHeaderVisible() {
      return (
        !this.guestBookHeader.visibility ||
        (this.guestPhase == "anonymous" &&
          this.guestBookHeader.visibility.anonymous) ||
        (this.guestPhase == "checkin" &&
          this.guestBookHeader.visibility.checkin) ||
        (this.guestPhase == "precheckin" &&
          this.guestBookHeader.visibility.precheckin)
      );
    },
  },
  computed: {
    appropriateImage() {
      // Check viewport
      if (window.matchMedia("(max-width: 500px)").matches) {
        return this.guestBookHeader.imagePath;
      } else {
        var desktopImage = this.guestBookHeader.imagePath.replace(
          this.$hotelId + "%2Fmobile%2Fmobile-375_",
          this.$hotelId + "%2Fdesktop%2Fdesktop-1000_"
        );
        return desktopImage;
      }
    },
    nameValue() {
      if (
        this.$route.params.guestPhase &&
        this.$route.params.guestPhase !== "anonymous"
      ) {
        return true;
      }

      let firstname;
      if (this.$route.params.name) {
        firstname = this.$route.params.name;
      } else {
        firstname = this.activeGuestInformation.name;
      }
      if (firstname) {
        this.setCookie("guestname", firstname, 7);
      } else {
        firstname = this.getCookie("guestname");
      }
      return firstname;
    },
    roomValue() {
      if (
        this.$route.params.guestPhase &&
        this.$route.params.guestPhase === "checkin"
      ) {
        return true;
      }
      let room = this.activeGuestInformation.roomnumber;
      if (room) {
        this.setCookie("guestroom", room, 7);
      } else {
        room = this.getCookie("guestroom");
      }
      return room;
    },
    includeName() {
      return this.guestBookHeader.includeName && this.nameValue;
    },
    includeRoom() {
      return this.guestBookHeader.includeRoom && this.roomValue;
    },
    nameFieldText() {
      if (
        this.$route.params.guestPhase &&
        this.$route.params.guestPhase !== "anonymous"
      ) {
        return "Guest name";
      }
      if (this.secondLang && this.cookieExists) {
        return this.guestBookHeader.dynamicGreetingNameSec.replace(
          /##firstname##/i,
          this.nameValue
        );
      } else {
        return this.guestBookHeader.dynamicGreetingName.replace(
          /##firstname##/i,
          this.nameValue
        );
      }
    },
    roomFieldText() {
      if (
        this.$route.params.guestPhase &&
        this.$route.params.guestPhase === "checkin"
      ) {
        return "Room nr.";
      }
      if (this.secondLang && this.cookieExists) {
        return this.guestBookHeader.dynamicGreetingRoomSec.replace(
          /##room##|##roomnumber##/i,
          this.roomValue
        );
      } else {
        return this.guestBookHeader.dynamicGreetingRoom.replace(
          /##room##|##roomnumber##/i,
          this.roomValue
        );
      }
    },
  },
};
</script>

<style scoped>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 100%;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.guestbook-header {
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  padding: 20px 20px 0 20px;
}

.guestbook-header__header {
  height: 52px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  margin-bottom: 20px;
}

.guestbook-header__header__item {
  display: flex;
  align-items: center;
}

.icon__person {
  margin: 0 8px 0 16px;
}

.icon__room {
  margin: 0 16px 0 8px;
}

.guestbook-header__main {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

.guestbook-header__main__image-container,
.guestbook-header__main__video-container {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 360px;
  border-radius: 8px 8px 0 0;
  overflow: hidden; /* Hide the corners not within the border-radius */
}

.guestbook-header__main__image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
}

.guestbook-header__main__text {
  width: 100%;
  padding: 16px;
  border-radius: 0 0 8px 8px;
  font-size: 12px;
  overflow-y: hidden;
}

/* Defaults on text from tiny MCE editor */
/* Use deep selector ">>>" for targeting v-html generated elements */
.guestbook-header__main__text >>> p,
.guestbook-header__main__text >>> h1,
.guestbook-header__main__text >>> h2,
.guestbook-header__main__text >>> h3,
.guestbook-header__main__text >>> h4,
.guestbook-header__main__text >>> h5,
.guestbook-header__main__text >>> h6 {
  margin: 0 0 12px 0;
  text-align: left;
}

/* Whatever textbox is last, dont add margin */
.guestbook-header__main__text >>> *:last-child {
  margin-bottom: 0;
}

@media screen and (min-width: 700px) {
  .guestbook-header {
    width: 700px;
    max-width: none;
  }
}

@media screen and (min-width: 1040px) {
  .guestbook-header {
    width: 1040px;
  }

  .guestbook-header__main {
    display: flex;
    flex-direction: row-reverse;
    height: 360px;
  }

  .guestbook-header__main__image-container,
  .guestbook-header__main__video-container {
    border-radius: 0 8px 8px 0;
  }

  .guestbook-header__main__text {
    max-width: 400px;
    border-radius: 8px 0 0 8px;
  }
}
</style>
